export default "__VITE_ASSET__aa40bbe3__"